import { render, staticRenderFns } from "./login-view.vue?vue&type=template&id=a890c0ba&scoped=true"
import script from "./login-view.vue?vue&type=script&lang=js"
export * from "./login-view.vue?vue&type=script&lang=js"
import style0 from "./login-view.vue?vue&type=style&index=0&id=a890c0ba&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a890c0ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a890c0ba')) {
      api.createRecord('a890c0ba', component.options)
    } else {
      api.reload('a890c0ba', component.options)
    }
    module.hot.accept("./login-view.vue?vue&type=template&id=a890c0ba&scoped=true", function () {
      api.rerender('a890c0ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login-view.vue"
export default component.exports